import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const tokenValue = this.authService.getToken();
    console.info('[AuthGuard] Checking authentication', {
      hasToken: !!tokenValue,
      url: state.url,
    });

    const tokenStatus = await this.authService.testToken();

    if (tokenStatus?.valid) {
      return true;
    } else {
      console.warn('[AuthGuard] Redirecting to core');
      if (!this.authService.redirectToCore()) {
        this.router.navigate(['/login']);
      }
      return false;
    }
  }
}
